import {
  BILLING_CYCLE,
  planTypes,
  billingCycleDependBasePlanTypeList,
  licenseDependBasePlanTypeList,
  PlanModelInfo,
} from '@/common/constants';
import { getCartInfo } from '@/common/service/default-mapper';
import { planUnitMap } from '@/common/product-unit'

const usersLimit = { max: 9999, min: 1 };

function pickInfo(planNode) {
  const result = [];
  const cmbPlanMap = {
    [BILLING_CYCLE.ANNUAL]: 'cmb_annual',
    [BILLING_CYCLE.MONTHLY]: 'cmb_monthly',
    [BILLING_CYCLE.QUARTERLY]: 'cmb_quarterly',
    [BILLING_CYCLE.TWO_YEARS]: 'cmb_two_years',
    [BILLING_CYCLE.THREE_YEARS]: 'cmb_three_years',
  };
  Object.keys(cmbPlanMap).forEach((currentBillingCycle) => {
    const onlinePlan = planNode[cmbPlanMap[currentBillingCycle]];
    if (onlinePlan) {
      const { prices, plan_code, plan_type } = onlinePlan;
      const formattedPlan = {
        type: planTypes.CONCURRENCY_MEETING_BASIC,
        category: 'CCM',
        sub_type: 'CCM',
        plan_code: plan_code,
        plan_type,
        amount: prices[0].price,
        prices,
        cartInfo: getCartInfo(),
        billing_cycle: currentBillingCycle,
        typeNameKey: 'billing.concurrent_meeting_basic.title',
        planNameKey: 'billing.concurrent_meeting_basic.title',
        supportCoupon: true,
        dependBasePlanTypeList: [],
        billingCycleDependBasePlanTypeList,
        // BUY TRIAL
        // FREE TRIAL
        isOnlineFreeTrial: false,
        trialDays: undefined,
        trialCode: '',
        ...usersLimit,
        licenseDependBasePlanTypeList,
        unit: planUnitMap.license,
        planModel: PlanModelInfo.license
      };

      result.push(formattedPlan);
    }
  });
  return result;
}
export default (planMapJSON) => pickInfo(planMapJSON.cmb_price_list || {});
